import { render, staticRenderFns } from "./Imo.vue?vue&type=template&id=2cdf5b91"
import script from "./Imo.vue?vue&type=script&lang=ts"
export * from "./Imo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports